var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form-item",
        {
          attrs: {
            label: "菜单类型",
            "label-col": { span: 6 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c(
            "a-radio-group",
            {
              model: {
                value: _vm.type,
                callback: function ($$v) {
                  _vm.type = $$v
                },
                expression: "type",
              },
            },
            [
              _c("a-radio", { attrs: { value: 0 } }, [_vm._v("目录")]),
              _c("a-radio", { attrs: { value: 1 } }, [_vm._v("菜单")]),
              _c("a-radio", { attrs: { value: 2 } }, [_vm._v("按钮")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 6 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c(
            "a-form-item",
            { attrs: { label: "名称" } },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["name", _vm.rules.name],
                    expression: "['name', rules.name]",
                  },
                ],
              }),
            ],
            1
          ),
          _c(
            "a-form-item",
            { attrs: { label: "是否使用" } },
            [
              _c("a-switch", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["isUse", { valuePropName: "checked" }],
                    expression: "['isUse',{ valuePropName: 'checked' }]",
                  },
                ],
                attrs: {
                  "checked-children": "是",
                  "un-checked-children": "否",
                },
              }),
            ],
            1
          ),
          _vm.type === 1
            ? _c(
                "a-form-item",
                { attrs: { label: "业务编号" } },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["bussinessNo"],
                        expression: "['bussinessNo']",
                      },
                    ],
                    attrs: { maxLength: 30 },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.type === 1 || _vm.type === 2
            ? _c(
                "a-form-item",
                { attrs: { label: "上级菜单" } },
                [
                  _c("a-tree-select", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["parentId"],
                        expression: "['parentId']",
                      },
                    ],
                    attrs: {
                      "allow-clear": "",
                      "dropdown-style": {
                        maxHeight: "300px",
                        overflow: "auto",
                      },
                      treeData: _vm.treeData,
                      replaceFields: {
                        children: "children",
                        title: "name",
                        key: "menuId",
                        value: "menuId",
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.type === 1
            ? _c(
                "a-form-item",
                { attrs: { label: "菜单URL" } },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["url", _vm.rules.url],
                        expression: "['url',rules.url]",
                      },
                    ],
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.type === 1 || _vm.type === 2
            ? _c(
                "a-form-item",
                { attrs: { label: "授权标识" } },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["perms"],
                        expression: "['perms']",
                      },
                    ],
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.type === 0 || _vm.type === 1
            ? _c(
                "a-form-item",
                { attrs: { label: "排序号" } },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["orderNum"],
                        expression: "['orderNum']",
                      },
                    ],
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.type === 0 || _vm.type === 1
            ? _c(
                "a-form-item",
                { attrs: { label: "图标" } },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["icon"],
                        expression: "['icon']",
                      },
                    ],
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save(false)
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }